"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTwoFactorCodeSms = sendTwoFactorCodeSms;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _types = require("./types");
var _apiUsersAuthenticateSendConfirmationCode = require("../../repositories/monolith-cian-realty/unversioned/api-users-authenticate-send-confirmation-code");
const _excluded = ["subdomain"];
async function sendTwoFactorCodeSms(dependencies, parameters) {
  const {
    httpApi,
    logger
  } = dependencies;
  const {
      subdomain
    } = parameters,
    restParameters = (0, _objectWithoutProperties2.default)(parameters, _excluded);
  try {
    const sendCodeResponse = await (0, _apiUsersAuthenticateSendConfirmationCode.fetchApiUsersAuthenticateSendConfirmationCode)({
      httpApi,
      parameters: restParameters,
      config: {
        subdomain,
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    if (sendCodeResponse.statusCode !== 200) {
      return {
        status: _types.ESendTwoFactorCodeStatus.Failed,
        message: sendCodeResponse.response.message
      };
    }
    return {
      status: _types.ESendTwoFactorCodeStatus.Succeed,
      senderType: _types.ESenderType.Sms,
      secondsToRetry: 60,
      timeStamp: new Date().getTime()
    };
  } catch (ex) {
    logger.error(ex, {
      domain: 'auth-widget.api.sendTwoFactorCodeSms'
    });
    return {
      status: _types.ESendTwoFactorCodeStatus.Failed,
      message: 'Произошла непредвиденная ошибка'
    };
  }
}